// This file must be present so auto.require.config.js will find and pre-require this module
define('configuration/evicommon.authentication.service.configuration',['require','exports','module','fukit'],function(require, exports, module) {
  var FuKit = require('fukit');

  module.exports = FuKit.EvicommonAuthenticationServiceConfiguration;
});

